<div [formGroup]="editForm" class="k-form" *ngIf="loaded">
    <button kendoButton [primary]="true" (click)="addFlag()" type="button" class="mb-2" *ngIf="!isDeleted">
        {{'ADD-FLAG' | translate}}<i class="far fa-plus"></i>
    </button>
    <div formGroupName="flags" class="container-flags">
        <table class="table mb-0">
            <thead>
                <tr>
                    <th>
                        <label class="control-label k-text-uppercase dark font-weight-normal">{{ 'CATEGORY' | translate
                            }}
                            *
                        </label>
                    </th>
                    <th>
                        <label class="control-label k-text-uppercase dark font-weight-normal">{{ 'PRIORITY' | translate
                            }}
                            *
                        </label>
                    </th>
                    <th *ngIf="false">
                        <label class="control-label k-text-uppercase dark font-weight-normal text-center">{{ 'PRIVATE' |
                            translate }}
                        </label>
                    </th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr style="position:relative;top:10px" *ngIf=" editForm.controls.flags.controls.length === 0">
                    {{'NO-RULES-SUMMARY' | translate}}
                </tr>
                <tr *ngFor="let flag of editForm.controls.flags.controls; let i=index; trackBy:flagsTrackBy;">
                    <td style="width:55%" [formGroupName]="i">
                        <kendo-combobox id="category" formControlName="category" [data]="flagCategories"
                            [textField]="'displayName'" [valueField]="'id'" class="w-100" tabindex="1"
                            (valueChange)="categoryChanged($event, flagControl, i)">
                            <ng-template kendoComboBoxItemTemplate let-dataItem>
                                <i class="fas {{dataItem.icon}}" style="color:gray;"></i>&nbsp;{{ dataItem.displayName
                                }}
                            </ng-template>
                        </kendo-combobox>
                        <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="editForm.controls.flags.controls[i].controls.category.hasError('required') && 
                            editForm.controls.flags.controls[i].controls.category.touched">
                            {{ 'CATEGORY-REQUIRED' | translate }}
                        </div>
                        <div class="mt-2">
                            <label>
                                <span class="k-text-uppercase dark">
                                    {{'FLAG' | translate}} *
                                </span>
                            </label>
                            <kendo-autocomplete #flagControl
                                [data]="editForm.controls.flags.controls[i].controls.allFlagsFiltered.value"
                                [valueField]="'displayName'" [textField]="'displayName'" [virtual]="virtualFlag"
                                class="w-100" [suggest]="true" [highlightFirst]="true" [filterable]="true"
                                (filterChange)="filterFlags($event,i)" (close)="searchTerm=''"
                                (click)="flagControl.toggle(true)" formControlName="description" tabindex="2">
                                <ng-template kendoAutoCompleteItemTemplate let-dataItem>
                                    <div class="ellipsis-text w-100" title="{{dataItem.displayName}}"
                                        innerHTML="{{ dataItem.displayName | highlight : searchTerm }}">
                                    </div>
                                </ng-template>
                            </kendo-autocomplete>
                            <div class="k-tooltip k-tooltip-validation" role="alert"
                                *ngIf="editForm.controls.flags.controls[i].controls.description.hasError('required') && editForm.controls.flags.controls[i].controls.description.touched">
                                {{ 'FLAG-REQUIRED' | translate }}
                            </div>
                        </div>
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                            *ngIf="editForm.controls.flags.controls[i].controls.importError.value">
                            {{ 'ASSESSMENT-DATA-PARTIALLY-LOADED-HINT' | translate }}
                        </div>
                        <div class="mt-2">
                            <app-formly-designer-rule-edit [ruleIndex]="i" [fields]="fields" [isDeleted]="isDeleted"
                                [showRules]="editForm.controls.flags.controls[i].controls.showRules.value"
                                [query]="editForm.controls.flags.controls[i].controls.query.value"
                                (showRulesChanged)="showRulesChanged($event)">
                            </app-formly-designer-rule-edit>
                        </div>
                    </td>
                    <td style="width:40%" [formGroupName]="i">
                        <kendo-combobox id="priority" formControlName="priority" [data]="flagPriorities"
                            [textField]="'displayName'" [valueField]="'id'" tabindex="3" class="w-50">
                            <ng-template kendoComboBoxItemTemplate let-dataItem>
                                <i class="fa fa-circle flag-priority-color-{{dataItem.code}}"></i>
                                &nbsp;{{ dataItem.displayName }}
                            </ng-template>
                        </kendo-combobox>
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                            *ngIf="editForm.controls.flags.controls[i].controls.priority.hasError('required') && editForm.controls.flags.controls[i].controls.priority.touched">
                            {{ 'PRIORITY-REQUIRED' | translate }}
                        </div>
                    </td>
                    <td *ngIf="false" class="text-center" style="width:15%" [formGroupName]="i">
                        <kendo-switch formControlName="privacy" onLabel="{{'YES' | translate }}"
                            offLabel="{{'NO' | translate }}" tabindex="4">
                        </kendo-switch>
                    </td>
                    <td class="ng-untouched" *ngIf="!isDeleted">
                        <a title="{{ 'DELETE' | translate }}" (click)="removeFlag(i)">
                            <i class="fas fa-fw fa-times-circle fa-delete-custom">&nbsp;</i>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>